export const homeStrings = {
    title: 'Inkdex',
    subtitle: 'Seu site brasileiro para busca de cartas de Lorcana!',
    searchButtonLabel: 'Buscar',
    cardLoadingMessage: 'Processando dados dos cards...'
}

export const headerStrings = {
    homeButton: 'INÍCIO',
    deckbuilderButton: 'CRIAR DECK',
    myDecksButton: 'DECKS',
    articlesButton: 'ARTIGOS',
    enterWithGoogle: 'Entre com o Google'
}

export const loadingAuth = {
    logging: 'Entrando com o Google...',
    loggingOut: 'Saindo da sua conta...'
}

export const changeTheme = 'Tema';

export const deckBuilderStrings = {
    initialVersion: '1.0.0',
    defaultPageTitle: 'Criar novo deck',
    editPageTitle: 'Editar Deck',
    version: 'Versão',
    name: 'Nome',
    description: 'Descrição',
    decklist: 'Lista do deck (decklist)',
    maybeboard: 'Lista de possibilidades (maybeboard)',
    saveDeckButton: 'Salvar Deck'
}

export const deckViewerStrings = {
    version: 'Versão: ',
    description: 'Descrição',
    decklist: 'Lista do deck (decklist)',
    maybeboard: 'Lista de possibilidades (maybeboard)',
    editPageButton: 'Editar Deck',
}

export const myDecksStrings = {
    noDecks: 'Você ainda não tem decks'
}